export default {
  state: {
    news: null,
    isNewsLoad: false,
    currentNews: null
  },
  mutations: {
    setNews(state, payload) {
      state.news = payload;
    },
    setLoadNews(state, payload) {
      state.isNewsLoad = payload;
    },
    setCurrentNews(state, payload) {
      state.currentNews = payload;
    },
  },
  actions: {
    loadNews: ({
      commit
    }, payload) => {
      //if(payload.isArray()){

      commit("setNews", payload);
      /* }
      else{
        commit("setNews", []);
      } */
    },
    setLoadNews: ({
      commit
    }, payload) => {
      commit("setLoadNews", payload);
    },
    setCurrentNews: ({
      commit
    }, payload) => {
      commit("setCurrentNews", payload);
    },
  },
  getters: {
    // Return categories (for get id)
    getNews(state) {
      return state.news;
    },
    getLoadNews(state) {
      return state.isNewsLoad;
    },
    getCurrentNews(state) {
      return state.currentNews;
    },

  }
}
